export default "__VITE_ASSET__sVS9FlIL__"